// Date and datetime-local inputs work in the browser's local time; the API speaks UTC
// instants. Slicing an ISO string gives the UTC date or time, which is a different day or
// hour for anyone east of Greenwich, and new Date('YYYY-MM-DD') reads the date as UTC
// midnight. These helpers keep both ends in local time.

const pad = (n) => String(n).padStart(2, '0');

/** An instant as the value of an <input type="date">, in local time; '' when missing. */
export const toLocalDateInput = (iso) => {
  if (!iso) return '';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

/** An instant as the value of an <input type="datetime-local">, in local time; '' when missing. */
export const toLocalDateTimeInput = (iso) => {
  const date = toLocalDateInput(iso);
  if (!date) return '';
  const d = new Date(iso);
  return `${date}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

/** The first moment of a local calendar day ('YYYY-MM-DD') as an ISO instant. */
export const startOfLocalDay = (date) => new Date(`${date}T00:00:00`).toISOString();

/** The last second of a local calendar day ('YYYY-MM-DD') as an ISO instant. */
export const endOfLocalDay = (date) => new Date(`${date}T23:59:59`).toISOString();
